// Mesmas conferências do backend (payment-hub-adonis, DocumentValidator.ts): aqui só adiantam o
// aviso na tela; quem decide é o backend. Só validam, nunca reescrevem o dado.

export function onlyDigits(value) {
    return String(value ?? '').replace(/\D/g, '')
}

function hasRepeatedDigits(digits) {
    return /^(\d)\1+$/.test(digits)
}

function checkDigit(digits, weights) {
    const sum = weights.reduce((total, weight, index) => total + Number(digits[index]) * weight, 0)
    const rest = sum % 11

    return rest < 2 ? 0 : 11 - rest
}

export function isValidCpf(value) {
    const digits = onlyDigits(value)
    if (digits.length !== 11 || hasRepeatedDigits(digits)) return false

    return checkDigit(digits, [10, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(digits[9]) &&
        checkDigit(digits, [11, 10, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(digits[10])
}

export function isValidCnpj(value) {
    const digits = onlyDigits(value)
    if (digits.length !== 14 || hasRepeatedDigits(digits)) return false

    return checkDigit(digits, [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(digits[12]) &&
        checkDigit(digits, [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]) === Number(digits[13])
}

export function isValidDocument(value) {
    return isValidCpf(value) || isValidCnpj(value)
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
const DOCUMENT_KEY_PATTERN = /^[\d.\-/\s]+$/
const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export function isValidEmail(value) {
    const email = String(value ?? '').trim()

    return email.length <= 254 && EMAIL_PATTERN.test(email)
}

export function isValidPixKey(type, key) {
    const value = String(key ?? '').trim()
    if (!value) return false

    switch (type) {
        // a chave vai ao fornecedor como digitada: letras no meio não podem passar
        case 'CPF':
            return DOCUMENT_KEY_PATTERN.test(value) && isValidCpf(value)
        case 'CNPJ':
            return DOCUMENT_KEY_PATTERN.test(value) && isValidCnpj(value)
        case 'EMAIL':
            return value.length <= 77 && EMAIL_PATTERN.test(value)
        case 'PHONE': {
            if (!/^[\d\s()+-]+$/.test(value)) return false
            const digits = onlyDigits(value)

            return digits.length >= 10 && digits.length <= 13
        }
        case 'RANDOM_KEY':
        case 'EVP':
        case 'TOKEN':
            return UUID_PATTERN.test(value)
        default:
            return false
    }
}
